/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoards } from 'app/entities/tumor-board/tumor-board.reducer';
import { MemberRole } from 'app/shared/model/enumerations/member-role.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-member.reducer';

export const TumorBoardMemberUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoards = useAppSelector(state => state.tumorBoard.entities);
  const tumorBoardMemberEntity = useAppSelector(state => state.tumorBoardMember.entity);
  const loading = useAppSelector(state => state.tumorBoardMember.loading);
  const updating = useAppSelector(state => state.tumorBoardMember.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardMember.updateSuccess);
  const memberRoleValues = Object.keys(MemberRole);

  const handleClose = () => {
    navigate(`/tumor-board-member${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoards({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.joinedAt !== undefined && typeof values.joinedAt !== 'number') {
      values.joinedAt = Number(values.joinedAt);
    }
    if (values.leftAt !== undefined && typeof values.leftAt !== 'number') {
      values.leftAt = Number(values.leftAt);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardMemberEntity,
      ...values,
      tumorBoard: tumorBoards.find(it => it.id.toString() === values.tumorBoard?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          memberRole: 'DOCTOR',
          ...tumorBoardMemberEntity,
          tumorBoard: tumorBoardMemberEntity?.tumorBoard?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorBoardMember.home.createOrEditLabel" data-cy="TumorBoardMemberCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorBoardMember.home.createOrEditLabel">Create or edit a TumorBoardMember</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-member-id"
                  label={translate('tinyMedicRestApp.tumorBoardMember.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.joinedAt')}
                id="tumor-board-member-joinedAt"
                name="joinedAt"
                data-cy="joinedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="joinedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.joinedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.left')}
                id="tumor-board-member-left"
                name="left"
                data-cy="left"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="leftLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.left" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.leftAt')}
                id="tumor-board-member-leftAt"
                name="leftAt"
                data-cy="leftAt"
                type="text"
              />
              <UncontrolledTooltip target="leftAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.leftAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.memberId')}
                id="tumor-board-member-memberId"
                name="memberId"
                data-cy="memberId"
                type="text"
              />
              <UncontrolledTooltip target="memberIdLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.memberId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.memberRole')}
                id="tumor-board-member-memberRole"
                name="memberRole"
                data-cy="memberRole"
                type="select"
              >
                {memberRoleValues.map(memberRole => (
                  <option value={memberRole} key={memberRole}>
                    {translate(`tinyMedicRestApp.MemberRole.${memberRole}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="memberRoleLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.memberRole" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.active')}
                id="tumor-board-member-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.cursor')}
                id="tumor-board-member-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.lastUpdated')}
                id="tumor-board-member-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.microSec')}
                id="tumor-board-member-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardMember.timestampEntry')}
                id="tumor-board-member-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-member-tumorBoard"
                name="tumorBoard"
                data-cy="tumorBoard"
                label={translate('tinyMedicRestApp.tumorBoardMember.tumorBoard')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoards
                  ? tumorBoards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-board-member" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardMemberUpdate;
